module.exports = __webpack_public_path__ + "public/img/tiku_cbg1.50785742.png";